import React, { createContext, useState, useContext, ReactNode } from 'react';

interface StockData {
  [key: string]: any;
}

interface StockDataContextType {
  stockData: StockData;
  setStockData: (stockData: StockData) => void;
}

const StockDataContext = createContext<StockDataContextType | undefined>(undefined);

export const StockDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [stockData, setStockData] = useState<StockData>({});

  return (
    <StockDataContext.Provider value={{ stockData, setStockData }}>
      {children}
    </StockDataContext.Provider>
  );
};

export const useStockData = (): StockDataContextType => {
  const context = useContext(StockDataContext);
  if (!context) {
    throw new Error('useStockData must be used within a StockDataProvider');
  }
  return context;
};
